import LoadingSpinner from './loading_spinner';

export default LoadingSpinner;
